import { chartConfig } from '@/config/chart';
import { getLocalChartState, initChartSettings } from '@/helpers/chartHelper';
import { useAppSelector } from '@/state/hooks';
import { selectLanguage } from '@/state/reducers/languageSlice';
import { selectAppliedTheme } from '@/state/reducers/themeSlice';
import { IChartingLibraryWidget, LanguageCode } from '@/types/charting_library';
import useCSSVariables from '@/utils/hooks/useCSSVariables';
import { useDatafeed } from '@/utils/hooks/useDatafeed';
import { useEffect, useMemo, useRef } from 'react';
import { useLocale } from 'react-aria';

export default function AdvancedChartView({ id, chartInstrument, isEnlarged = false }: any) {
    const lang = useAppSelector(selectLanguage);
    const appliedTheme = useAppSelector(selectAppliedTheme);

    const { locale } = useLocale();
    const chartId = useMemo(() => `tv_chart_${id}${isEnlarged ? '_enlarged' : ''}`, [id]);
    const elementId = useMemo(() => `tv_chart_container_${id}${isEnlarged ? '_enlarged' : ''}`, [id, isEnlarged]);

    const datafeed = useDatafeed(id, chartId, chartInstrument);
    const variables = useCSSVariables();

    const widgetRef = useRef<IChartingLibraryWidget | null>(null);

    useEffect(() => {
        window[chartId] = {};
        if (window[chartId]) window[chartId].chartLoaded = false;

        const chartState = getLocalChartState(id);
        if (chartState) {
            chartState.charts[0].panes[0].sources[0].state.symbol = chartInstrument?.celer;
            localStorage.setItem(`chartState-${id}`, JSON.stringify(chartState));
        } else {
            if (window[chartId]) window[chartId].chartLoaded = true;
        }

        const localization: LanguageCode =
            lang === 'en'
                ? 'en'
                : lang === 'dk'
                ? 'da_DK'
                : lang === 'zh'
                ? 'zh'
                : lang === 'ar'
                ? 'ar'
                : lang === 'es'
                ? 'es'
                : 'en';

        const TVWidget = new window.TradingView.widget(
            chartConfig(elementId, chartInstrument, localization, locale, datafeed, variables, appliedTheme)
        );
        if (window[chartId]) window[chartId].TVWidget = TVWidget;
        TVWidget.onChartReady(() => {
            widgetRef.current = TVWidget;
            if (chartState) {
                TVWidget.load(chartState);
                if (window[chartId]) window[chartId].chartLoaded = true;
            }
            initChartSettings(TVWidget, variables);

            const widget = TVWidget as any;
            widget._iFrame.onload = () => {
                const chartState = getLocalChartState(id);
                setTimeout(() => {
                    if (chartState) TVWidget.load(chartState);
                    initChartSettings(TVWidget, variables);
                }, 100);
            };
        });
        return () => {
            widgetRef.current?.remove?.();
        };
    }, [lang, chartInstrument]);

    return <div id={elementId} className="h-full" />;
}
